"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: var(--color-grey-light-1);\n  min-height: 10rem;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: #fff;\n  border: 1px solid var(--color-grey-light-3);\n  border-radius: 3px;\n  padding: 1.5rem;\n  /* max-height: 75vh; */\n  overflow: scroll;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.StyledGalleryCardDiv = styled_components_1.default.div(_templateObject());
exports.StyledGalleryContentDiv = styled_components_1.default.div(_templateObject2());